module.exports = __webpack_public_path__ + "static/media/jauharabad-dark.5fc1c08a.svg";